"use strict";
exports.__esModule = true;
//# sourceMappingURL=bulle-talk-slice.js.map